import { useEffect, useState } from "react";

import useFirmWorkingHours from "./hooks/useFirmWorkingHours";

import "./working-hours.css";

const toTimeInput = (value) => (value || "").slice(0, 5);

const WorkingHours = () => {
  const { data, loading, saveWorkingHours } = useFirmWorkingHours();
  const [form, setForm] = useState({
    start_time: "08:00",
    end_time: "17:00",
    work_days: [0, 1, 2, 3, 4],
    restrict_to_work_days: false,
  });
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    setForm({
      start_time: toTimeInput(data.start_time),
      end_time: toTimeInput(data.end_time),
      work_days: data.work_days,
      restrict_to_work_days: data.restrict_to_work_days,
    });
  }, [data]);

  const toggleDay = (day) => {
    setForm((current) => ({
      ...current,
      work_days: current.work_days.includes(day)
        ? current.work_days.filter((value) => value !== day)
        : [...current.work_days, day].sort((a, b) => a - b),
    }));
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (!form.work_days.length) {
      return;
    }
    if (form.end_time <= form.start_time) {
      return;
    }

    setSaving(true);
    try {
      await saveWorkingHours(form);
    } catch (requestError) {
      console.error(requestError);
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="working-hours-settings">
      <form onSubmit={handleSubmit}>
        <div className="working-hours-card">
          <div className="working-hours-title">Firm working hours</div>
          <p className="working-hours-description">
            These hours are used by the calendar Work Hours view for everyone at the firm.
          </p>

          <div className="working-hours-time-row">
            <div>
              <label htmlFor="firm-work-start">Start time</label>
              <input
                id="firm-work-start"
                type="time"
                className="form-control"
                value={form.start_time}
                disabled={loading || saving}
                onChange={(event) =>
                  setForm((current) => ({ ...current, start_time: event.target.value }))
                }
                required
              />
            </div>
            <div>
              <label htmlFor="firm-work-end">End time</label>
              <input
                id="firm-work-end"
                type="time"
                className="form-control"
                value={form.end_time}
                disabled={loading || saving}
                onChange={(event) =>
                  setForm((current) => ({ ...current, end_time: event.target.value }))
                }
                required
              />
            </div>
          </div>

          <fieldset disabled={loading || saving}>
            <legend>Working days</legend>
            <div className="working-hours-days">
              {data.weekday_choices.map((choice) => (
                <label key={choice.value} htmlFor={`firm-work-day-${choice.value}`}>
                  <input
                    id={`firm-work-day-${choice.value}`}
                    type="checkbox"
                    checked={form.work_days.includes(choice.value)}
                    onChange={() => toggleDay(choice.value)}
                  />
                  <span>{choice.label}</span>
                </label>
              ))}
            </div>
          </fieldset>

          <label className="working-hours-restriction" htmlFor="firm-work-restrict">
            <input
              id="firm-work-restrict"
              type="checkbox"
              checked={form.restrict_to_work_days}
              disabled={loading || saving}
              onChange={(event) =>
                setForm((current) => ({
                  ...current,
                  restrict_to_work_days: event.target.checked,
                }))
              }
            />
            <span>Exclude events on non-working weekdays from the calendar Work Hours feed</span>
          </label>

          <div className="working-hours-actions">
            <button className="btn btn-success" type="submit" disabled={loading || saving}>
              Save Working Hours
            </button>
          </div>
        </div>
      </form>
    </div>
  );
};

export default WorkingHours;
